<style lang="scss" scoped>
// thead {
//     position: sticky;
//     top: -50px;
//     z-index: 999;
//     background: #fff !important;

//     th {
//         background: #fff !important;
//         padding-top: 10px;
//         padding-bottom: 10px;
//     }
// }

// table {
//     min-width: 1650px;

//     td {
//         align-items: center;
//     }
// }

// .campaignName {
//     font-size: 20px !important;
// }

@media (max-width: 600px) {
    .nomobile {
        display: none !important;
    }
}

.badge {
    width: 70px;
    overflow: hidden;
    font-size: 20px;
    white-space: nowrap;
    background: rgba(#000, 0.05);
    padding: 1px 4px;
    box-sizing: border-box;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    height: 24px;
    margin: 0 1px;

    &.standalone {
        background-color: rgb(41, 74, 182);
        color: #fff;
    }

    &.conversions {
        background: rgba(27, 192, 115, 0.05);
        box-shadow: 0 0 0 2px rgb(27, 192, 115);
        font-weight: 700;
        color: rgb(22, 179, 105);
        // color: #fff;
    }

    &.dlc {
        background-color: rgb(69, 199, 203);
        color: #fff;
    }

    &.web {
        background-color: rgb(241, 213, 241);
    }

    &.demo {
        background-color: rgb(241, 223, 213);
    }

    svg {
        margin-right: 5px;
        margin-left: -1px;
        margin-top: 4px;
        // display: none;
        font-size: 10px !important;
        // margin-right: auto;
    }

    &.inactive {
        opacity: 0.15;
        color: transparent;
    }
}

.badgeGroup {
    display: inline-flex;
    align-items: center;
    border: 2px dotted rgba(#000, 0.2);
    padding: 5px;
    margin: 0 4px;
    border-radius: 5px;
    background: rgba(#fff, 0.5);

    .dividerIcon {
        opacity: 0.5;
        margin: 4px 3px 0 !important;
        font-size: 10px !important;
    }
}

.dividerIcon {
    color: #777;
    margin: 0 8px 0 !important;
    display: inline-flex;
    vertical-align: middle;
    font-size: 14px !important;
    border-radius: 4px;

    &.secondary {
        opacity: 0.5;
        margin: 2px 3px 0 !important;
        font-size: 10px !important;
    }
}

.links {
    display: flex;
    flex-direction: column;

    .link {
        display: grid;
        grid-template-columns: 250px auto;
        margin-bottom: 15px;
        background: #eee;
        align-items: center;
        grid-gap: 5px;
        border-radius: 10px;
        padding: 6px 10px;

        @media (max-width: 600px) {
            min-width: unset;
            grid-template-columns: 1fr;
        }

        position: relative;

        &.summaryRow {
            background: #ddd;
        }

        .campaignName {
            font-size: 20px;
            color: #000;
            margin-bottom: 5px;
            width: 100%;
            overflow: hidden;
            word-wrap: break-word;
            white-space: wrap;
            display: flex;
            flex-direction: column;

            .metaCampaignLink {
                display: flex;
                flex-direction: column;
                font-size: 0.8em;
                .campaignid::before {
                    content: "Campaign";
                }
                .adgroupid::before {
                    content: "Ad Group";
                }
                .creativeid::before {
                    content: "Creative";
                }

                .campaignid,
                .adgroupid,
                .creativeid {
                    &::before {
                        text-transform: uppercase;
                        font-size: 0.7em;
                        width: 55px;
                        display: flex;
                        margin-bottom: -4px;
                        margin-top: 4px;
                        color: #aaa;
                    }
                }
            }
        }
    }

    .funnel {
        display: flex;
        align-items: center;
        color: #333;

        @media (max-width: 600px) {
            // flex-direction: column;
        }

        .deleteButton {
            margin-left: 10px;
            background: #ddd;
            color: #000;
        }

        .multiStep {
            display: flex;
            flex-direction: column;
            margin-left: 10px;
            gap: 3px;

            @media (max-width: 600px) {
                margin-left: 0;
                // flex-direction: row;
                // margin: 0;

                // > .path {
                //     flex-direction: column;
                // }
            }

            > .path {
                display: flex;
                align-items: center;
                border: 1px solid #aaa;
                border-radius: 5px;
                &.helper {
                    border-color: transparent;
                }
            }
        }

        .statbox {
            // background: #ddd;
            margin-left: auto;
            height: 100%;
            padding: 10px;
            // border-radius: 4px;
            display: flex;
            flex-direction: column;
            font-size: 14px;
            > .stat {
                display: grid;
                grid-template-columns: 180px 80px;
                > .value {
                    font-weight: 600;
                }
            }
        }

        .funnelStep {
            height: 55px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            padding: 10px 5px;
            background: #ddd;
            border-radius: 4px;
            box-sizing: border-box;
            width: 80px;
            position: relative;

            @media (max-width: 600px) {
                width: 50px;
                height: 35px;
                flex-direction: row;
                > .icon {
                    margin-right: 3px;
                }
            }

            &.inactive {
                opacity: 0.3;
                background: transparent !important;
            }

            .title {
                text-transform: uppercase;
                display: none;
                font-size: 14px;
            }

            .icon {
                color: #000;
                opacity: 0.4;
                font-size: 18px;
                // position: absolute;
                // top: -9px;
                // left: -5px;
            }

            .amount {
                font-weight: bold;
            }

            &.signal-web {
                background-color: rgb(182, 245, 244);
            }
            &.signal-demo {
                background-color: rgb(161, 242, 195);
            }
            &.signal-steam {
                background-color: rgb(231, 155, 254);
            }
            &.signal-dlc {
                background-color: rgb(255, 187, 136);
            }
        }

        .funnelTransfer {
            height: 50px;
            width: 50px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            justify-content: center;
            flex-direction: column;

            @media (max-width: 600px) {
                // flex-direction: row;
                height: 35px;
                width: 45px;
                // > .icon {
                //     margin-right: 3px;
                //     transform: rotate(90deg);
                // }
            }

            &.stepSize {
                width: 80px;
            }
            .icon {
                font-size: 12px;
            }
            .amount {
                white-space: nowrap;
                // background: #ddd;
                // padding: 4px;
                // border-radius: 4px;
                font-size: 14px;
                margin-top: 5px;
                overflow: hidden;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.smallicon {
    margin-right: 10px;
    font-size: 0.7em;
    position: relative;
    top: -2px;
    display: inline-flex;
}
</style>

<template lang="pug">
div
  h1 Conversions
    button.icon(@click="refreshData")
      fa(icon="sync-alt")

  select(v-model="selectedRange")
    option(v-for="[key, range] in Object.entries(ranges)", :value="key") {{ range.label }}

  label
    input(v-model="filter", placeholder="Filter ...")
    button(@click="filter = ''") All
    | &nbsp;
    button(@click="filter = 'ga_'") Google Ads
    | &nbsp;
    button(@click="filter = 'fb_'") FB Ads
    | &nbsp;
    button(@click="filter = 'rdt_'") Reddit Ads
    | &nbsp;
    button(@click="filter = 'twt_'") Twitter Ads
  | &nbsp;
  label
    input(type="checkbox" v-model="hideLowAmount")
    | Hide low click amount

  .boxes
    key-stat-box(title="Total Users", :value="keyStats.totalUsers")
    key-stat-box(
      title="Est. Revenue (filtered)",
      :value="formatCurrency(keyStats.totalRevenueGenerated) + '€'"
    )
    key-stat-box(
      title="Conversions: Standalone",
      :value="keyStats.totalStandalonePurchases"
    )
    key-stat-box(
      title="Cracks: Standalone",
      :value="keyStats.totalCracked"
    )
    key-stat-box(
      title="Conversions: DLC",
      :value="keyStats.totalPuzzleDlcPlays"
    )
    key-stat-box(title="Plays: Web", :value="keyStats.totalWebPlays")
    key-stat-box(
      title="Plays: Demo",
      :value="keyStats.totalDemoPlays"
    )

  .links(v-if="links")
    .link(v-for="link in links", :class="{ summaryRow: link.$aggregated}")
      .campaignName

          .metaCampaignLink(v-if="link.meta")
            a.campaignid(:href="link.meta.link", target="_blank")
              template(v-if="link.meta.reference") {{link.meta.reference.campaignname}}
              template(v-else) {{link.meta.campaignid}}
            .adgroupid.nomobile {{link.meta.adgroupid}}
            .creativeid.nomobile {{link.meta.creativeid}}

          template(v-else) {{link.initialCampaign}}
      .funnel

        //- .test {{campaignToMeta(link.initialCampaign)}}
        .funnelStep(:class="{inactive: link.users < 1}")
          fa.icon(icon="user")
          .title Users
          .amount {{ formatNumber(link.users) }}

        .funnelTransfer.nomobile
          fa.icon(icon="arrow-right")
          .amount {{(link.totalClicks / link.users).toFixed(1)}}

        .funnelStep.nomobile(:class="{inactive: link.totalClicks < 1}")
          fa.icon(icon="mouse-pointer")
          .title Clicks
          .amount {{ formatNumber(link.totalClicks) }}

        .funnelTransfer.nomobile
          fa.icon(icon="random")
          .amount {{((link.web + link.demo) / link.users * 100.0).toFixed(1)}} %

        .multiStep.nomobile
          .path
            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.web / link.users  * 100.0).toFixed(1)}} %

            .funnelStep(:class="{inactive: link.web < 1}")
              fa.icon(icon="globe")
              .title shapez.io
              .amount {{ formatNumber(link.web) }}

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.webStarted / Math.max(1, link.web)  * 100.0).toFixed(1)}} %

            .funnelStep(:class="{inactive: link.webStarted < 1}")
              fa.icon(icon="play")
              .title Level 1
              .amount {{ formatNumber(link.webStarted) }}

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.webFinished / Math.max(1,link.webStarted) * 100.0).toFixed(1)}} %

            .funnelStep.signal-web(:class="{inactive: link.webFinished < 1}")
              fa.icon(icon="flag-checkered")
              .title Completed
              .amount {{ formatNumber(link.webFinished) }}


          .path

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.demo / link.users  * 100.0).toFixed(1)}} %


            .funnelStep(:class="{inactive: link.demo < 1}")
              fa.icon(icon="gamepad")
              .title Steam Demo
              .amount {{ formatNumber(link.demo) }}

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.demoStarted / Math.max(1, link.demo)  * 100.0).toFixed(1)}} %

            .funnelStep(:class="{inactive: link.demoStarted < 1}")
              fa.icon(icon="play")
              .title Level 1
              .amount {{ formatNumber(link.demoStarted) }}

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.demoFinished / Math.max(1,link.demoStarted) * 100.0).toFixed(1)}} %

            .funnelStep.signal-demo(:class="{inactive: link.demoFinished < 1}")
              fa.icon(icon="flag-checkered")
              .title Completed
              .amount {{ formatNumber(link.demoFinished) }}



        .multiStep
          .path

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.standalonePurchases / Math.max(link.users, 1)  * 100.0).toFixed(1)}} %


            .funnelStep.signal-steam(:class="{inactive: link.standalonePurchases < 1}")
              fa.icon(icon="tag")
              .title Buy Game
              .amount {{ formatNumber(link.standalonePurchases) }}

          .path

            .funnelTransfer
              fa.icon(icon="arrow-right")
              .amount {{(link.puzzleDlc / Math.max(link.users, 1)  * 100.0).toFixed(1)}} %

            .funnelStep.signal-dlc(:class="{inactive: link.puzzleDlc < 1}")
              fa.icon(icon="puzzle-piece")
              .title Buy DLC
              .amount {{ formatNumber(link.puzzleDlc) }}

        .funnelTransfer
          fa.icon(icon="arrow-right")

        .funnelStep(:class="{inactive: conversionCount(link) < 1}")
          fa.icon(icon="euro-sign")
          .title Revenue
          .amount {{ formatCurrency(link.revenue) }}


        .funnelTransfer
          fa.icon(icon="arrow-right")

        .funnelStep(:class="{inactive: conversionCount(link) < 1}")
          fa.icon(icon="mouse-pointer")
          .title User Revenue
          .amount {{ formatCurrency(link.revenue / link.users) }}€


        .statbox.nomobile
          .stat
            .label Revenue per unique user
            .value {{ formatCurrency(link.revenue / link.users) }}€
          .stat
            .label Expected total revenue
            .value {{ formatCurrency(calculateEstimatedRevenue(link)) }}€
          .stat
            .label Cracked
            .value {{ link.standaloneCracks }}
          .stat
            .label Already had the game
            .value {{ link.standalonePlays - link.standalonePurchases }} ({{((link.standalonePlays - link.standalonePurchases) / link.users * 100.0).toFixed(1) }} %)
          .stat
            .label Bought DLC but had game
            .value {{ link.puzzleDlcPlays - link.puzzleDlc }} ({{((link.puzzleDlcPlays - link.puzzleDlc) / link.users * 100.0).toFixed(1) }} %)

        //- button.deleteButton.nomobile(v-if="!link.$aggregated" @click="deleteCampaign(link.initialCampaign)") X


      //- .conversions
      //-     .badge.standalone(v-if="link.standalone > 0")
      //-       | {{((link.standalone / link.totalClicks) * 100.0).toFixed(1) }} %
      //-     .badge.dlc(v-if="link.puzzleDlc > 0")
      //-       | {{((link.puzzleDlc / link.totalClicks) * 100.0).toFixed(1) }} %

</template>

<script>
import ApiService from "../services/api";
import KeyStatBox from "../components/KeyStatBox";

function readCampaignData() {
    const campaignData = require("./campaigns.json")["2"];
    const payload = campaignData.map(p => JSON.parse(p))[0][1];

    const campaigns = payload.map(p => ({
        campaignid: +p["2"],
        adgroupid: +p["3"],
        campaignname: p["11"],
    }));

    return campaigns;
}

const CAMPAIGNS = readCampaignData();

const todaySeconds = new Date();
todaySeconds.setHours(0, 0, 0, 0);

export default {
    components: { KeyStatBox },
    data: () => ({
        hideLowAmount: false,
        updateInterval: null,
        keyStats: {
            totalClicks: null,
            totalStandalonePurchases: null,
            totalWebPlays: null,
            totalPuzzleDlcPlays: null,
            totalDemoPlays: null,
            totalRevenueGenerated: null,
            totalUsers: null,
            totalCracked: null,
        },
        selectedRange: "day",
        ranges: {
            today: {
                label: "Today",
                intervalAmount: "$today",
                intervalUnit: "seconds",
            },
            today_steam: {
                label: "Today (steam)",
                intervalAmount: "$today_steam",
                intervalUnit: "seconds",
            },
            yesterday_steam: {
                label: "Since Yesterday (steam)",
                intervalAmount: "$yesterday_steam",
                intervalUnit: "seconds",
            },
            yesterday: {
                label: "Since Yesterday",
                intervalAmount: "$yesterday",
                intervalUnit: "seconds",
            },
            hour: {
                label: "1 hour",
                intervalAmount: 60,
                intervalUnit: "minute",
            },
            hours_6: {
                label: "6 hours",
                intervalAmount: 6,
                intervalUnit: "hour",
            },
            day: {
                label: "24 hours",
                intervalAmount: 24,
                intervalUnit: "hour",
            },

            day2: {
                label: "2 days",
                intervalAmount: 24 * 2,
                intervalUnit: "hour",
            },

            day3: {
                label: "3 days",
                intervalAmount: 24 * 3,
                intervalUnit: "hour",
            },

            week: {
                label: "7 days",
                intervalAmount: 24 * 7,
                intervalUnit: "hour",
            },
            month: {
                label: "1 month",
                intervalAmount: 30,
                intervalUnit: "day",
            },
            two_months: {
                label: "2 Months",
                interval2Amount: 60,
                intervalUnit: "day",
            },
            three_months: {
                label: "3 Months",
                intervalAmount: 90,
                intervalUnit: "day",
            },
            year: {
                label: "12 Months",
                intervalAmount: 965,
                intervalUnit: "day",
            },
        },
        filter: "rdt_",
        links: null,
    }),
    mounted() {
        this.refreshData();
        this.updateInterval = setInterval(() => this.refreshData(), 5000);
    },
    beforeDestroy() {
        clearInterval(this.updateInterval);
    },
    watch: {
        filter() {
            this.refreshData();
        },
        selectedRange() {
            this.refreshData();
        },
        hideLowAmount() {
            this.refreshData();
        },
    },

    methods: {
        async refreshData() {
            let initialFilter = this.filter;

            this.keyStats = {
                totalClicks: null,
                totalUsers: null,
                totalStandalonePurchases: null,
                totalWebPlays: null,
                totalPuzzleDlcPlays: null,
                totalRevenueGenerated: null,
                totalDemoPlays: null,
                totalCracked: null,
            };

            const range = this.ranges[this.selectedRange];

            let intervalAmount = range.intervalAmount;
            let intervalUnit = range.intervalUnit;
            if (intervalAmount === "$today") {
                intervalAmount = Math.ceil((new Date().getTime() - todaySeconds.getTime()) / 1000.0);
                intervalUnit = "seconds";
            }

            const todaySteam = new Date();
            todaySteam.setHours(9, 0, 0, 0);

            const todayMorning = new Date();
            todayMorning.setHours(0, 0, 0, 0);
            if (intervalAmount === "$today_steam") {
                intervalAmount = Math.ceil((new Date().getTime() - todaySteam.getTime()) / 1000.0);
                intervalUnit = "seconds";
            }
            if (intervalAmount === "$yesterday_steam") {
                intervalAmount = Math.ceil(
                    (new Date().getTime() - todaySteam.getTime() + 24 * 60 * 60 * 1000) / 1000.0
                );
                intervalUnit = "seconds";
            }
            if (intervalAmount === "$yesterday") {
                intervalAmount = Math.ceil(
                    (new Date().getTime() - todayMorning.getTime() + 24 * 60 * 60 * 1000) / 1000.0
                );
                intervalUnit = "seconds";
            }

            const nowFilter = `(now() - interval '${intervalAmount} ${intervalUnit}')`;

            let whereClause = `
        where
          (
            "clickedAt" > ${nowFilter}
          )
  `;
            // or "purchasedAt" > ${nowFilter}
            if (this.filter) {
                whereClause += ` and ("initialCampaign" ilike '%${this.filter
                    .replace(/[^a-z0-9\-_]/gi, "")
                    .replace(/_/gi, "\\_")}%') `;
            }

            const data = (
                await ApiService.query(`
        select
          count(*)::int as "totalUsers",
          sum(LEAST("linkClicks", 5))::int as "totalClicks",

          sum("standalonePlays")::int as "totalStandalone",
          sum(coalesce("steamOwnsApp"::int,0))::int as "totalStandalonePurchases",

          sum("webPlays")::int as "totalWebPlays",
          sum("puzzleDlcPlays" * coalesce("steamOwnsApp"::int,0))::int as "totalPuzzleDlcPlays",
          sum("launchedWithoutSteam")::int as "totalCracked",
          sum("demoPlays")::int as "totalDemoPlays",
          sum(coalesce("purchasePriceGame", 0) * coalesce("steamOwnsApp"::int,0) + coalesce("purchasePriceDlc", 0) * coalesce("steamOwnsApp"::int,0) * "puzzleDlcPlays")::float as "totalRevenueGenerated"

          from link_tracking
          ${whereClause}
      `)
            )[0];

            if (this.filter !== initialFilter) {
                return;
            }

            this.keyStats = data;

            let linksResult = await ApiService.query(`
            select
                "initialCampaign",
                count(*)::int as users,
                sum(LEAST("linkClicks", 100))::int as "totalClicks",

                sum("standalonePlays")::int as "standalonePlays",
                sum(coalesce("steamOwnsApp"::int,0))::int as "standalonePurchases",
                sum("launchedWithoutSteam")::int as "standaloneCracks",



                sum("webPlays")::int as web,
                sum("demoPlays")::int as demo,

                sum("puzzleDlcPlays" * coalesce("steamOwnsApp"::int,0))::int as "puzzleDlc",
                sum("puzzleDlcPlays"* "steamOwnsApp"::int)::int as "puzzleDlcPlays",

                sum(LEAST("webMaxLevel", 1))::int as "webStarted",
                sum(LEAST("demoMaxLevel", 1))::int as "demoStarted",

                sum(coalesce("purchasePriceGame", 0) * coalesce("steamOwnsApp"::int,0) + coalesce("purchasePriceDlc", 0) * coalesce("steamOwnsApp"::int,0) * "puzzleDlcPlays")::float as "revenue",

                sum(LEAST(GREATEST("demoMaxLevel" - 7, 0), 1))::int as "demoFinished",
                sum(LEAST(GREATEST("webMaxLevel" - 7, 0), 1))::int as "webFinished"

            from link_tracking
            ${whereClause}
            group by "initialCampaign"
            order by "revenue" desc, "users" desc
        `);

            // sum(GREATEST(  LEAST("webMaxLevel", 1)   - 1 + coalesce("steamOwnsApp"::int,0)  , 0))::int as "purchasedAfterWebStarted",
            // sum(GREATEST(  LEAST("demoMaxLevel", 1)   - 1 + coalesce("steamOwnsApp"::int,0)  , 0))::int as "purchasedAfterDemoStarted",

            // sum(GREATEST(  LEAST(GREATEST("webMaxLevel" - 7, 0), 1)   - 1 + coalesce("steamOwnsApp"::int,0)  , 0))::int as "purchasedAfterWebFinished",
            // sum(GREATEST(  LEAST(GREATEST("demoMaxLevel" - 7, 0), 1)   - 1 + coalesce("steamOwnsApp"::int,0)  , 0))::int as "purchasedAfterDemoFinished"

            if (this.filter !== initialFilter) {
                return;
            }

            if (this.hideLowAmount) {
                linksResult = linksResult.filter(link => link.users > 2);
            }

            linksResult.forEach(link => (link.meta = this.campaignToMeta(link.initialCampaign)));

            const props = [
                "users",
                "totalClicks",
                "standalonePurchases",
                "standalonePlays",
                "web",
                "demo",
                "puzzleDlc",
                "webStarted",
                "demoStarted",
                "demoFinished",
                "webFinished",
                "revenue",
                "puzzleDlcPlays",
                "standaloneCracks",
                // "purchasedAfterWebStarted",
                // "purchasedAfterDemoStarted",
                // "purchasedAfterWebFinished",
                // "purchasedAfterDemoFinished",
            ];
            let aggregated = {};
            for (const prop of props) {
                aggregated[prop] = linksResult.reduce((v, link) => v + link[prop], 0);
            }

            linksResult.unshift({
                $aggregated: true,
                ...aggregated,
                initialCampaign: "",
            });

            this.links = linksResult;
        },

        calculateEstimatedRevenue(link) {
            return (link.demoStarted * 0.93) / 0.975 + (link.webStarted * 0.27) / 0.815;
        },

        campaignToMeta(campaignId) {
            const parts = /_([0-9]{6,15})_([0-9]{6,15})_([0-9]{6,15})$/.exec(campaignId);

            if (parts) {
                const [, campaignid, adgroupid, creativeid] = parts;

                const reference = CAMPAIGNS.find(
                    c => +c.campaignid == +campaignid || +c.adgroupid == +adgroupid
                );

                return {
                    campaignid,
                    adgroupid,
                    creativeid,
                    reference,
                    link: "https://ads.google.com/aw/overview?campaignId=" + campaignid,
                };
            }

            return null;
        },

        conversionCount(link) {
            return link.standalonePurchases + link.puzzleDlc;
        },

        formatCurrency(value) {
            // if (value > 999.99) {
            //     return Math.round(value).toLocaleString("de-DE");
            // }
            return new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" })
                .format(value)
                .replace("€", "")
                .replace(/\s/gi, "");
        },

        formatNumber(value) {
            if (!value) {
                return 0;
            }
            if (value > 9999) {
                return (value / 1000).toFixed(1) + "k";
            }
            return String(value);
        },

        async deleteCampaign(name) {
            if (confirm("Are you sure you want to delete the campaign '" + name + "'?")) {
                // todo
                await ApiService.query(
                    `
                delete from link_tracking where "initialCampaign" = ~campaign
            `,
                    { campaign: name }
                );
                await this.refreshData();
            }
        },
    },
};
</script>
